import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const senecBadgeTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            badge: {
                color: theme.palette.white.main,
            },
        },
    };
};
